import { useEffect, useRef } from "react";

const useLockBodyScroll = ({
	toggle,
	inertNodeId = "root",
}: {
	toggle: boolean;
	inertNodeId?: string;
}): void => {
	const position = useRef(window.scrollY);
	const inertNode = document.getElementById(inertNodeId);

	useEffect(() => {
		const originalStyle: string = window.getComputedStyle(
			document.body,
		).overflow;

		if (toggle) {
			position.current = window.scrollY;
			inertNode?.setAttribute("inert", "");
		}
		document.body.style.overflow = toggle ? "hidden" : "";
		document.body.style.top = toggle ? `-${position.current}px` : "";
		document.body.style.height = toggle ? "100dvh" : "";
		document.body.style.position = toggle ? "fixed" : "";

		window.scrollTo(0, position.current);

		return () => {
			document.body.style.overflow = originalStyle || "";
			inertNode?.removeAttribute("inert");
		};
	}, [inertNode, toggle]);
};

export default useLockBodyScroll;
